<div
  class="dashletBody__container"
  #dashletActivities
  (scroll)="onScroll($event)"
  (drag)="onDrag($event)"
  (click)="dashletClicked($event)"
>
  <div class="dashletBody">
    @if (!fetched) {
      <pp-dashlet-activities-placeholder></pp-dashlet-activities-placeholder>
    } @else {
      @if (activities.length > 0) {
        <ul
          #activityList
          (ppOnRendered)="dashletActivitiesRendered$.next()"
          class="dashletActivities__ul"
        >
          @for (activity of activities; track activity; let i = $index) {
            <pp-dashlet-activity
              [ppActivity]="activity"
              [ppAllUsers]="allUsers"
              [ppWorkspaces]="workspaces"
            ></pp-dashlet-activity>
          }
        </ul>
        @if (allActivitiesLoaded) {
          <div>{{ 'end_of_activities' | ppTranslate }}</div>
        }
      } @else {
        <div>
          {{ 'no_recent_activity' | ppTranslate }}
        </div>
      }

      @if (ppLoading || !allActivitiesLoaded) {
        <div class="dashlet-activities-spinner">
          <pp-spinner [ppDashboard]="true"></pp-spinner>
        </div>
      }
    }
  </div>
</div>
